// extracted by mini-css-extract-plugin
var _1 = "TextareasOutline-moduletextareaSkeleton__qRUIE";
var _2 = "TextareasOutline-moduletextareaSkeletonBox__bPOMu";
export { _1 as "textareaSkeleton", _2 as "textareaSkeletonBox" }
